var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "page-boxed page-header-fixed page-sidebar-closed-hide-logo page-container-bg-solid page-sidebar-closed-hide-logo"
    },
    [
      _c(
        "div",
        [
          _c("PartnerHeader"),
          _vm._v(" "),
          _c("div", { staticClass: "clearfix" }),
          _vm._v(" "),
          _c("div", {}, [
            _c("div", { staticClass: "page-container" }, [
              _c(
                "div",
                { staticClass: "page-sidebar-wrapper" },
                [_c("PartnerSide")],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "page-content-wrapper" },
                [
                  _c(
                    "div",
                    { staticClass: "page-content" },
                    [_c("router-view", { attrs: { name: "partner" } })],
                    1
                  ),
                  _vm._v(" "),
                  _c("PartnerFooter")
                ],
                1
              )
            ])
          ])
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9fbfbf68", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9fbfbf68","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PartnerPanel.vue
// module id = null
// module chunks = 